import api from './api';

const accountAppAuthService = {
  startSession: async (phoneNumber, proxyId = '') => {
    const response = await api.post('/account-app-auth/sessions', { phoneNumber, proxyId });
    return response.data;
  },

  listProxies: async () => {
    const response = await api.get('/account-app-auth/proxies');
    return response.data;
  },

  createProxy: async ({ label, proxyUrl }) => {
    const response = await api.post('/account-app-auth/proxies', { label, proxyUrl });
    return response.data;
  },

  deleteProxy: async (proxyId) => {
    const response = await api.delete(`/account-app-auth/proxies/${proxyId}`);
    return response.data;
  },

  checkProxy: async (proxyId) => {
    const response = await api.post(`/account-app-auth/proxies/${proxyId}/check`);
    return response.data;
  },

  getSession: async (sessionId) => {
    const response = await api.get(`/account-app-auth/sessions/${sessionId}`);
    return response.data;
  },

  submitCode: async (sessionId, code) => {
    const response = await api.post(`/account-app-auth/sessions/${sessionId}/code`, { code });
    return response.data;
  },

  submitPassword: async (sessionId, password) => {
    const response = await api.post(`/account-app-auth/sessions/${sessionId}/password`, { password });
    return response.data;
  },

  cancelSession: async (sessionId) => {
    const response = await api.post(`/account-app-auth/sessions/${sessionId}/cancel`);
    return response.data;
  },

  consumeSession: async (sessionId) => {
    const response = await api.post(`/account-app-auth/sessions/${sessionId}/consume`);
    return response.data;
  }
};

export default accountAppAuthService;
